import { client } from '../client';

export interface Payload {
  email: string;
  confirmation_code: string;
  is_email_update?: boolean;
}

export interface VerifyConfirmationResponse {
  access_token: string;
  refresh_token: string;
}

export const verifyConfirmationCode = async (payload: Payload): Promise<VerifyConfirmationResponse> => {
  const { data } = await client.post<VerifyConfirmationResponse>(`/auth/verify_confirmation_code`, payload);

  return data;
};
